/*
 * /quiz (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { QuizTable } from "../../features/quiz/components/quiz-table"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/quiz/")({
	component: QuizPage,
	loader: authPageLoader,
})

function QuizPage() {
	const { user } = Route.useLoaderData()

	const { data: quizzes, isLoading: quizzesLoading } =
		trpc.quiz.getAllByFilter.useQuery({
			where: {},
			pagination: { limit: 100 },
		})

	const { data: quizResults, isLoading: resultsLoading } =
		trpc.quizResult.getAllByFilter.useQuery({
			where: { userId: user.id },
			pagination: { limit: 100 },
		})

	if (quizzesLoading || resultsLoading) {
		return (
			<Page centerVertical={true}>
				<Container width={"xl"} padding={"lg"}>
					<div className={"text-center"}>{"Loading..."}</div>
				</Container>
			</Page>
		)
	}

	const quizData =
		quizzes?.map((quiz) => {
			const quizResult = quizResults?.find(
				(result) => result.quizId === quiz.id,
			)
			return { ...quiz, result: quizResult }
		}) || []

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Quizzes"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<h4>
					{"Quizzes can be completed at "}
					<a
						href={"https://embrace-autism.com/autism-tests/"}
						target={"_blank"}
						rel={"noopener noreferrer"}
						className={"text-primary underline"}
					>
						{"Embrace Autism"}
					</a>
					{
						", please complete the quizzes through their links below and record the final scores."
					}
				</h4>
				<div
					className={
						"flex size-full flex-row flex-wrap items-center justify-center gap-3"
					}
				>
					<QuizTable userId={user.id} quizData={quizData} />
				</div>
			</Container>
		</Page>
	)
}
